<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card class="custom-shadow-card-header">
          <!-- FILTROS -->
          <el-collapse v-model="activeName" @change="handleCollapse">
            <el-collapse-item :title="titleFilter" name="filter">
              <filter-component
                @filter="handleFilter"
                @showHideLoading="showHideLoading"
                :filterOfLots="false"
                :filterOfFarms="false"
              >
                <template slot="prev">
                  <select-component
                    class="pt-3"
                    :rowClass="`col-12 col-sm-6 col-xl-4`"
                    :labelSelect="`${$t(
                      'boxinspection.inspection_location'
                    )}: `"
                    :dataOptions="locations"
                    :initialSelection="dataFilter.location_ids"
                    @onChange="handleChangeSelected"
                    modelName="location_ids"
                  />

                  <select-component
                    class="pt-3"
                    :rowClass="`col-12 col-sm-6 col-xl-4`"
                    :labelSelect="`${$t('common_words.farms')}: *`"
                    :dataOptions="farms"
                    :requireClass="`required-farm-id`"
                    :initialSelection="dataFilter.farm_ids"
                    @onChange="handleChangeSelected"
                    modelName="farm_ids"
                  />

                  <select-component
                    class="pt-3"
                    :rowClass="`col-12 col-sm-6 col-xl-3`"
                    :labelSelect="`${$t('common_words.report_typeof')}: *`"
                    :dataOptions="reportTypes"
                    :requireClass="`required-report-type`"
                    :initialSelection="dataFilter.report_type"
                    :isMultiple="false"
                    @onChange="handleChangeSelected"
                    modelName="report_type"
                  />
                </template>
              </filter-component>
            </el-collapse-item>
          </el-collapse>

          <!-- GRAFICAS -->
          <div class="col-12 mt-5" v-if="hasData">
            <card
              class="custom-shadow-card-header"
              :title="$t('boxinspection.quality_percentage_pcms')"
            >
              <span>
                <div class="row">
                  <div class="col-12">
                    <highcharts :options="chartOptions[1]"></highcharts>
                  </div>
                </div>
              </span>
            </card>
          </div>

          <div class="col-12 mt-5" v-if="hasData">
            <card
              class="custom-shadow-card-header"
              :title="$t('boxinspection.percentage_defects')"
            >
              <span>
                <div class="row">
                  <div class="col-12">
                    <highcharts :options="chartOptions[0]"></highcharts>
                  </div>
                </div>
              </span>
            </card>
          </div>

          <!-- TABLA -->
          <card v-if="tableData.length > 0">
            <div v-if="isIndex()">
              <card-header
                :propPagination="pagination"
                @searchedQuery="handleSearchQuery"
                class="mr-3 mt-4"
              />
              <master-table
                :infoTable="queriedData"
                :columns="tableColumns"
                :showColumnStatus="false"
              >
                <template
                  slot="addColumns"
                  v-if="dataFilter.report_type != 'consolidated'"
                >
                  <el-table-column
                    prop="defects"
                    :label="$t('production.defects')"
                    width="100"
                    :align="'left'"
                    type="expand"
                  >
                    <template slot-scope="scope">
                      <div v-if="scope.row.defects && scope.row.defects.length">
                        <template
                          v-for="(group, category) in groupDefects(
                            scope.row.defects
                          )"
                        >
                          <div style="margin-bottom: 6px">
                            <strong>{{ category }}:</strong>
                            <div
                              v-for="(item, index) in group"
                              :key="index"
                              style="margin-left: 10px"
                            >
                              - {{ item.defect }} ({{ item.clusters }})
                            </div>
                          </div>
                        </template>
                      </div>
                      <span v-else>-</span>
                    </template>
                  </el-table-column>
                </template>
              </master-table>

              <card-footer ref="cardfooter" :propPagination="pagination" />
              <div v-if="dataFilter.report_type === 'detailed'">
                <export-tables
                  :pdf="{
                    filename: '',
                    route: '',
                    showPDFButton: false,
                  }"
                  :xls="{
                    filename: `${$t(
                      'boxinspection.detailed_report_percentage_PCMS'
                    )}_${dataFilter.date_from}_${dataFilter.date_to}.xlsx`,
                    route: 'quality/pcmsreport/detailed/excel',
                    paramMethod: 'POST',
                    plusData: { ...getDataToExport },
                  }"
                />
              </div>
              <div v-if="dataFilter.report_type === 'consolidated'">
                <export-tables
                  :pdf="{
                    filename: '',
                    route: '',
                    showPDFButton: false,
                  }"
                  :xls="{
                    filename: `${$t(
                      'boxinspection.consolidated_report_percentage_PCMS'
                    )}_${dataFilter.date_from}_${dataFilter.date_to}.xlsx`,
                    route: 'quality/pcmsreport/consolidated/excel',
                    paramMethod: 'POST',
                    plusData: { ...getDataToExport },
                  }"
                />
              </div>

              <br />
            </div>
            <not-index-permissions v-else />
          </card>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import { Chart } from 'highcharts-vue';
import Highcharts from 'highcharts';
import drilldown from 'highcharts/modules/drilldown';
import exportingInit from 'highcharts/modules/exporting';
import Filter from 'src/components/Filter/Filters.vue';
import Formatter from 'src/class/Formatter.js';
import i18n from 'src/i18n';
import MixinCharts from 'src/util/mixinCharts';
import { MixinExport } from 'src/mixins/mixin-export';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import { MixinNotification } from 'src/mixins/mixin-notification';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import SweetAlert from 'src/class/Alerts';
import paginationData from 'src/views/Pages/Dashboard/Quality/BoxInspection/Master/paginationData';
import moment from 'moment';

drilldown(Highcharts);
exportingInit(Highcharts);

export default {
  name: 'PcmsReport',

  components: {
    [Filter.name]: Filter,
    highcharts: Chart,
  },

  data() {
    return {
      dataFilter: {
        farm_ids: null,
        location_ids: null,
        report_type: 'detailed',
        date_from: moment().subtract(1, 'year').format('YYYY-MM-DD'),
        date_to: moment().format('YYYY-MM-DD'),
        date_sel: null,
      },

      activeName: 'filter',
      valueCollapse: null,

      farms: [],
      locations: [],

      tableData: [],
      tableColumns: [],
      searchQuery: '',
      fuseSearch: null,

      pagination: paginationData.pagination,

      chartOptions: [{}, {}], // [0]=Defects, [1]=Quality

      hasData: false,
    };
  },

  computed: {
    ...paginationData.functions,

    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }
      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    reportTypes() {
      return [
        { id: 'detailed', name: i18n.t('common_words.detailed') },
        { id: 'consolidated', name: i18n.t('common_words.consolidated') },
      ];
    },
    getDataToExport() {
      const response = {
        data: this.tableData,
        date_sel: this.dataFilter.date_sel,
      };
      delete response.route;

      return response;
    },
    periodLabel() {
      switch (this.dataFilter.date_sel) {
        case 'Día':
          return this.$t('common_words.day');
        case 'Semana':
          return this.$t('common_words.week');
        case 'Mes':
          return this.$t('common_words.month');
        case 'Año':
          return this.$t('common_words.year');
        default:
          return this.$t('common_words.day');
      }
    },
  },

  mixins: [
    MixinPermissions,
    mixinMasters,
    MixinNotification,
    MixinValidations,
    MixinCharts,
    MixinExport,
  ],

  watch: {
    '$i18n.locale': 'setupTable',
    'dataFilter.report_type': 'setupTable',
    'dataFilter.date_sel': 'setupTable',
  },

  methods: {
    groupDefects(defects) {
      return defects.reduce((acc, d) => {
        const cat = d.category || 'Sin categoría';

        if (!acc[cat]) {
          acc[cat] = [];
        }

        acc[cat].push(d);
        return acc;
      }, {});
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    handleSearchQuery(query) {
      this.searchQuery = query;
    },

    handleChangeSelected(data) {
      this.$set(this.dataFilter, data.name, data.selects);
      this.tableData = [];
      this.hasData = false;
      this.$set(this.chartOptions, 0, {});
      this.$set(this.chartOptions, 1, {});
    },

    formatNumber(value) {
      return Formatter.formatNumber(Number(value));
    },

    // Seteo de Tablas consolidated y Detallado
    setupTable() {
      const type = this.dataFilter.report_type;

      if (type === 'consolidated') {
        this.tableColumns = [
          {
            prop: 'period',
            label: this.periodLabel,
            align: 'center',
            minWidth: 90,
          },
          {
            prop: 'farm',
            label: this.$t('common_words.farm'),
            align: 'center',
            minWidth: 150,
          },
          {
            prop: 'boxes',
            label: this.$t('production.boxes'),
            align: 'center',
            minWidth: 200,
          },
          {
            prop: 'avg_pcms',
            label: 'Prom. PCMS(%)',
            align: 'center',
            minWidth: 100,
            formatter: (row) => this.formatNumber(row.avg_pcms),
          },
        ];
      } else {
        this.tableColumns = [
          {
            prop: 'date_save',
            label: this.$t('common_words.date'),
            align: 'center',
            fixed: true,
            minWidth: 100,
          },
          {
            prop: 'farm',
            label: this.$t('common_words.farm'),
            align: 'center',
            fixed: true,
            minWidth: 180,
          },
          {
            prop: 'box',
            label: this.$t('production.box'),
            align: 'center',
            fixed: true,
            minWidth: 200,
          },
          {
            prop: 'location',
            label: this.$t('boxinspection.inspection_location_pcms'),
            align: 'center',
            minWidth: 160,
          },
          {
            prop: 'number_pallet',
            label: '# Pallet',
            align: 'center',
            minWidth: 90,
          },
          {
            prop: 'boxes_qty',
            label: this.$t('production.boxes_quantity'),
            align: 'center',
            minWidth: 110,
            formatter: (row) => this.formatNumber(row.boxes_qty),
          },
          {
            prop: 'avg_weight',
            label: this.$t('boxinspection.average_weight_pcms'),
            align: 'center',
            minWidth: 110,
            formatter: (row) => this.formatNumber(row.avg_weight),
          },
          {
            prop: 'avg_pcms',
            label: 'Prom. PCMS (%)',
            align: 'center',
            minWidth: 120,
            formatter: (row) => this.formatNumber(row.avg_pcms),
          },
          {
            prop: 'defects_qty',
            label: this.$t('boxinspection.number_defects'),
            align: 'center',
            minWidth: 120,
          },
        ];
      }

      this.pagination = { ...paginationData.pagination };
      this.pagination.perPage = 10;
      this.pagination.currentPage = 1;
      this.searchQuery = '';
    },

    // Funcion para filtrar
    handleFilter(data) {
      this.tableData = [];
      this.hasData = false;
      this.$set(this.chartOptions, 0, {});
      this.$set(this.chartOptions, 1, {});

      this.dataFilter = {
        ...this.dataFilter,
        date_from: data.datei,
        date_to: data.datef,
        date_sel: data.bySel,
      };

      if (!isset(this.dataFilter.farm_ids)) {
        return this.validationInputsRequired('farm-id');
      }

      if (!isset(this.dataFilter.report_type)) {
        return this.validationInputsRequired('report-type');
      }

      this.getData();
    },

    getData() {
      this.showHideLoading(true);

      let payload = {
        ...this.dataFilter,
        route: 'quality/pcmsreport/filter',
      };

      if (payload.date_sel === 'Año') {
        payload.date_from += '-01-01';
        payload.date_to += '-12-31';
      }

      Axios.postMasters(payload)
        .then((response) => {
          const res = response.data.data || {};
          this.tableData = res.table || [];
          this.hasData = this.tableData.length > 0;

          if (!this.hasData) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
            this.showHideLoading();
            return;
          }

          // Charts
          this.loadChartsFromBackend(res);

          // Search (filtro tabla)
          try {
            this.searchFuse(
              this.tableColumns.map((c) => c.prop),
              null,
              0.3
            );
          } catch (error) {
            console.log(error);
          }

          this.pagination.perPage = 10;
          this.pagination.currentPage = 1;
          this.searchQuery = '';

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message || 'Error');
        });
    },

    // Funcion que cargar la data del backend para graficarla
    loadChartsFromBackend(res) {
      const defectsPayload =
        res.charts && res.charts.defects
          ? res.charts.defects
          : { series: [], drilldown: [] };
      const qualityPayload =
        res.charts && res.charts.quality
          ? res.charts.quality
          : { series: [], drilldown: [] };

      let options0 = this.columns(defectsPayload, true);
      let options1 = this.columns(qualityPayload, true);

      // Botón a la izquierda
      const drillUpConfig = {
        drillUpButton: {
          position: {
            align: 'left',
            x: -3,
            y: -35,
          },
        },
      };

      options0.drilldown = { ...options0.drilldown, ...drillUpConfig };
      options1.drilldown = { ...options1.drilldown, ...drillUpConfig };

      // Se aplican los cambios al estado
      this.$set(this.chartOptions, 0, options0);
      this.$set(this.chartOptions, 1, options1);

      this.chartOptions[0].lang = {
        drillUpText: `${i18n.t('common_words.return_to')} {series.name}`,
      };

      this.chartOptions[1].lang = {
        drillUpText: `${i18n.t('common_words.return_to')} {series.name}`,
      };
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      this.setupTable();

      Promise.all([
        Axios.getMasters('farms/farms/onlyfruit'),
        Axios.getMasters('quality/locationinspections'),
      ])
        .then(([responseFarm, responseLocation]) => {
          this.farms = this.concatAll(
            responseFarm.data.data.map((farm) => ({
              ...farm,
              name: `${farm.code} - ${farm.name}`,
            }))
          );
          this.locations = this.concatAll(responseLocation.data.data);
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    } else {
      this.showHideLoading();
    }
  },
};
</script>
